// Zentrale Changelog-Daten
// Neueste Einträge immer oben einfügen

export const CHANGELOG_ENTRIES = [
  {
    version: '1.0.0',
    date: '2026-11-04T22:30:00',
    title: 'November 2026 – Fixes und neues Versionsschema',
    items: [
      {
        heading: 'Neues Versionsschema',
        body: [
          'Die SMA trägt ab jetzt Versionsnummern nach dem Schema MAJOR.MINOR.PATCH, beginnend mit 1.0.0. Die bisherigen Nummern 26.x sind damit abgelöst.'
        ]
      },
      {
        heading: 'Tickets / Fälle in der Kundenansicht',
        body: [
          'Die Tickets eines Kunden werden jetzt beim Wechsel zu einem anderen Kunden neu geladen und bleiben beim Nachladen der Kundendetails erhalten. Bisher zeigte die Ansicht in diesen Fällen „0 Tickets / Fälle“.'
        ]
      },
      {
        heading: 'Lead-Übernahme bringt Aufträge mit',
        body: [
          'Wird ein Unternehmen aus der Lead-Suche übernommen, das in Sugar bereits existiert, werden seine Aufträge und Abos jetzt mit in die SMA übernommen.'
        ]
      },
      {
        heading: 'Aufträge und Abos vollständig',
        body: [
          'Aufträge und Abos neu angelegter Geschäftspartner werden zuverlässig gespeichert. Änderungen an einzelnen Auftragspositionen in Sugar, etwa am Laufzeitende, kommen jetzt ebenfalls in der SMA an. Zwischenzeitlich verlorene Verträge wurden nachgeladen.'
        ]
      },
      {
        heading: 'Stabilität',
        body: [
          'Die Geschäftspartner-Ansicht öffnet sich auch dann, wenn gleichzeitig ein nächtlicher Abgleich läuft.',
          'Lange Vorgänge wie die Lead-Übernahme brechen nicht mehr nach 60 Sekunden ab.',
          'Nach einem Update lädt der Browser immer den aktuellen Stand der SMA statt einer zwischengespeicherten Version.',
          'Der nächtliche Geschäftspartner-Abgleich läuft weiter, wenn eine Datenbankverbindung zwischendurch abbricht.'
        ]
      }
    ]
  },
  {
    version: '26.3.3',
    date: '2026-10-12T15:00:00',
    title: 'Oktober 2026 – Fixes und Stabilisierungen',
    items: [
      {
        heading: 'Umverteilung von Aufgaben und Leads',
        body: [
          'Korrekturen bei der Umverteilungslogik, z.B. bei der Umbuchung von Leads zwischen zwei Sales Managern.'
        ]
      },
      {
        heading: 'Eigenrecherche ohne doppelte Geschäftspartner',
        body: [
          'Bei der Eigenrecherche „SMA vs. Google“ werden Geschäftspartner nicht mehr doppelt (neu) angelegt.'
        ]
      },
      {
        heading: 'Abgleich zwischen SMA und SugarCRM',
        body: [
          'Optimierungen bei der Synchronisation zwischen SMA und Sugar, unter anderem bei der Aktualisierung von Verknüpfungen.'
        ]
      },
      {
        heading: 'Termin-Feedback: Potentiale flexibel ergänzen',
        body: [
          'Potentiale lassen sich jetzt bei jedem Termin hinzufügen, auch bei Terminen aus der Eigenrecherche. Die Ansicht bleibt dabei an Ort und Stelle, sodass man direkt weiterarbeiten kann.'
        ]
      },
      {
        heading: 'Optimierte nächtliche Abgleiche',
        body: [
          'Der Abgleich von Kontaktlisten und Aufgaben ist zeitlich besser abgestimmt und läuft dadurch noch zuverlässiger.'
        ]
      }
    ]
  },
  {
    version: '26.3.2',
    date: '2026-10-08T15:00:00',
    title: 'Oktober 2026 – Abgleich mit Sugar',
    items: [
      {
        heading: 'Mahnstufen werden wieder zurückgesetzt',
        body: [
          'Hatte ein Kunde in Sugar keine Mahnstufe mehr (z.B. nach Zahlungseingang), blieb im SMA die alte Stufe stehen. Der nächtliche Abgleich übernimmt jetzt auch geleerte Felder: Mahnstufe, Sperrkanäle, Alias, Tour, Öffnungszeiten und Kundenstatus. Aufgehobene zentrale Sperren und zurückgenommene Kündigungen kommen ebenfalls an. Der Altbestand wird einmalig nachgezogen.'
        ]
      },
      {
        heading: 'Nächtlicher Kundenabgleich deutlich schneller',
        body: [
          'Der Abgleich der Kundendaten mit Sugar hatte jede Nacht fast alle Kunden als geändert behandelt und bis zu 19 Stunden gebraucht. Adresse und Umsätze werden jetzt korrekt verglichen, es werden nur noch echte Änderungen geschrieben.'
        ]
      },
      {
        heading: 'Stabilere nächtliche Jobs',
        body: [
          'Ist Sugar vorübergehend nicht erreichbar, beenden sich die nächtlichen Jobs mit einer klaren Meldung statt abzustürzen.'
        ]
      },
      {
        heading: 'Kundensuche mit aktuellen Sugar-Daten',
        body: [
          'Der angebundene Kundenindex erhielt seit Anfang Juli keine Änderungen aus Sugar mehr. Die Verbindung ist wiederhergestellt, neue und geänderte Kunden kommen wieder täglich an.'
        ]
      },
      {
        heading: 'Betrieb in der Sellwerk Cloud',
        body: [
          'Der SMA läuft seit dem 7. Oktober 2026 in der Sellwerk Cloud. Adressen, Logins und Funktionen bleiben gleich, die bisherige Umgebung wird abgeschaltet.'
        ]
      },
      {
        heading: 'Änderungsprotokoll direkt aufrufbar',
        body: [
          'Das Änderungsprotokoll lässt sich nach der Anmeldung direkt aufrufen und verlinken (/changelog), auch beim Neuladen der Seite. Bisher blieb der direkte Aufruf hängen. Der deaktivierte Knopf auf der Anmeldeseite entfällt.'
        ]
      }
    ]
  },
  {
    version: '26.3.1',
    date: '2026-09-30T10:00:00',
    title: 'September 2026 – Stabilität und Sicherheit',
    items: [
      {
        heading: 'Login-Weiterleitung abgesichert',
        body: [
          'In seltenen Fällen (z.B. beim erneuten Aufruf des Microsoft-Anmeldelinks) blieb man nach der Anmeldung dauerhaft auf dem Ladebildschirm „Du wirst eingeloggt“ hängen. Das ist jetzt behoben.'
        ]
      },
      {
        heading: 'Termin-Feedback: Speichern bei fehlendem Entscheider behoben',
        body: [
          'Ein Fehler verhinderte, dass ein Termin-Feedback gespeichert werden konnte, wenn kein gültiger Entscheider hinterlegt war. Das Speichern funktioniert jetzt in jedem Fall zuverlässig.'
        ]
      },
      {
        heading: 'Eigenrecherche: Abgleich mit bereits gefundenen Google-Treffern abgesichert',
        body: [
          'Der Abgleich gegen einen bereits bekannten Google-Treffer konnte in bestimmten Fällen den gesamten Übernahmevorgang abbrechen. Es erscheint jetzt stattdessen eine klare Fehlermeldung, ohne dass andere Übernahmen davon betroffen sind.'
        ]
      },
      {
        heading: 'Postleitzahlen mit führender Null korrekt übernommen',
        body: [
          'Postleitzahlen, die mit einer 0 beginnen (z.B. 01234), wurden beim Anlegen neuer Kunden teils verkürzt übertragen. Sie werden jetzt zuverlässig fünfstellig übernommen.'
        ]
      },
      {
        heading: 'Zuverlässigerer nächtlicher Abgleich des Tourenmaterials',
        body: [
          'Fehlerhafte Firmen-Datensätze konnten zu Störungen oder Abbrüchen im nächtlichen Abgleich und Update des Tourenmaterials führen. Das wurden nun behoben, der Abgleich überspringt betroffene Datensätze.'
        ]
      },
      {
        heading: 'Sicherheitsverbesserung bei der Suche in den Wiedervorlagen',
        body: [
          'Die Hervorhebung von Suchtreffern in den Wiedervorlagen wurde gehärtet: Sonderzeichen in Kundennamen oder Kommentaren konnten die Anzeige zuvor beeinträchtigen. Betroffen war ausschließlich die Darstellung im Browser, es sind keine Kunden- oder Zugangsdaten involviert.'
        ]
      }
    ]
  },
  {
    version: '26.3.0',
    date: '2026-09-09T10:00:00',
    title: 'September 2026 – Leads aus Formularen & Korrekturen bei Status und Bonität',
    items: [
      {
        heading: 'Hinweis bei fehlendem oder unvollständigem Entscheider',
        body: [
          'Wenn für einen verbindlichen Termin kein gültiger Entscheider ausgewählt werden kann, erscheint jetzt ein klarer Hinweis statt eines kommentarlos ausgeblendeten Speichern-Buttons.',
          'Je nach Fall wird angezeigt, ob nur die Anrede über „Bearbeiten“ ergänzt werden kann, oder ob stattdessen ein neuer, vollständiger Entscheider angelegt werden muss.'
        ]
      },
      {
        heading: 'Verbesserte Übernahme von Eigenrecherche-Leads',
        body: [
          'Leads, die über die Eigenrecherche angelegt werden, werden nun mit Branchen angelegt.',
          'Es werden nur noch Branchen übernommen, die mit hoher Sicherheit (Qualität A oder B) erkannt wurden – unsichere Branchenzuordnungen entfallen.',
          'Beim Anlegen wird zusätzlich zum Sugar-Lead automatisch ein passender Sugar-Account erzeugt. Schlägt ein Schritt fehl, wird der bereits angelegte Kunde sauber wieder zurückgenommen, statt in einem unvollständigen Zustand zu bleiben.',
          'Da diese Kunden dadurch von Anfang an einen Sugar-Account besitzen, können für sie nun auch Terminbestätigungen per E-Mail verschickt werden – das war zuvor mangels Sugar-Account technisch nicht möglich. Dies gilt für neu und künftig übernommene Eigenrecherche-Kunden, nicht rückwirkend für bereits früher übernommene.'
        ]
      },
      {
        heading: 'Korrekter Status bei mehrdeutiger Sales-Manager-Zuordnung',
        body: [
          'Ist ein Kunde mehreren Sales Managern zugeordnet, wird in der Kundenliste nun zuverlässig genau eine, zu dir passende Statuszeile angezeigt statt einer möglicherweise falschen oder mehrfachen Zuordnung.'
        ]
      },
      {
        heading: 'Winback-Kennzeichnung korrigiert',
        body: [
          'Die Winback-Markierung bei gekündigten Abos erschien bisher schon dann, wenn nur eines von Kündigungs- und Enddatum gesetzt war. Sie wird jetzt nur noch angezeigt, wenn beide Daten tatsächlich vorliegen.'
        ]
      },
      {
        heading: 'Bonitätsanzeige korrigiert',
        body: [
          'Kunden ohne nennenswerte Bonitätsauskunft zeigen jetzt zuverlässig „OK“ an – auch wenn Sugar dafür den Wert „0“ statt eines leeren Felds liefert.'
        ]
      },
      {
        heading: 'Speichern bei großen Datenmengen abgesichert',
        body: [
          'Kunden mit sehr vielen Aufträgen oder sonstigen Daten können jetzt wieder zuverlässig gespeichert werden.'
        ]
      }
    ]
  },
  {
    version: '26.2.0',
    date: '2026-07-30T10:00:00',
    title: 'Juli 2026 – Eigenrecherche, Kundenlisten, Reminder & mehr',
    sections: [
      {
        title: 'Eigenrecherche',
        items: [
          {
            heading: '1.1 Kapazitätserweiterung Eigenrecherche',
            body: [
              'Die Kapazität der Eigenrecherche wurde von 100 auf 150 Kunden erhöht.',
              'Die Kapazität zählt nun ausschließlich Kunden ohne Termin. Sobald ein übernommener Kunde terminiert wurde, wird der Platz automatisch wieder freigegeben.'
            ]
          },
          {
            heading: '1.2 Verbesserter Suchablauf',
            body: [
              'Der Ablauf der Eigenrecherche wurde optimiert. Die Verarbeitung erfolgt nun in folgender Reihenfolge: Matching-Service → Google → Matching.',
              'Durch neue Ladeanzeigen bleibt der aktuelle Status der Suche jederzeit sichtbar.'
            ]
          },
          {
            heading: '1.3 Überarbeiteter Button „Zur Liste“',
            body: [
              'Der Button „Zur Leads Liste“ führt nun direkt zu den eigenen Eigenrecherche-Listen mit bereits übernommenen Kunden.'
            ]
          },
          {
            heading: '1.4 Überarbeitete Bestandssuche',
            body: [
              'Die Bestandssuche wurde erweitert und bietet nun ein neues Formular, optimierte Abläufe und eine direkte Weiterleitung zur Übersicht.'
            ]
          },
          {
            heading: '1.5 Neue Struktur & zusätzliche Informationen',
            body: [
              'Die Eigenrecherche-Detailseite wurde neu aufgebaut: übersichtlichere Sortierung, zusätzliche Kundeninformationen, Gruppierung nach Übernah­möglichkeit und verständliche Statusanzeigen mit Erklärungen.'
            ]
          },
          {
            heading: '1.6 Neues Übernahme-Ergebnis',
            body: [
              'Nach einer Kundenübernahme erscheint nun eine Zusammenfassung mit erfolgreich übernommenen Kunden, nicht erfolgreichen Übernahmen sowie direkter Navigation zur Kundenliste und in einzelne Kunden.'
            ]
          },
          {
            heading: '1.7 Optimiertes Übersichtspanel',
            body: [
              'Das Übersichtspanel wurde erweitert. Die Verarbeitung der Suchvorgänge ist nun transparenter und der Wechsel zwischen den drei Sucharten wurde verbessert.'
            ]
          },
          {
            heading: '1.8 Neuer Qualitätsfilter',
            body: [
              'Ein neuer Qualitätsfilter wurde integriert, damit Qualitätsmerkmale der Kunden schnell eingesehen und berücksichtigt werden können.'
            ]
          }
        ]
      },
      {
        title: 'Kundenlisten',
        items: [
          {
            heading: '2.1 Verbesserte Funktion „Zur letzten Liste“',
            body: [
              'Der zuletzt manuell gesetzte Filter wird nun zuverlässig gespeichert und wiederhergestellt.'
            ]
          },
          {
            heading: '2.2 Optimierte Spaltenreihenfolge',
            body: [
              'Name und Adresse befinden sich nun vor den Umsatzinformationen, damit wichtige Kundendaten schneller sichtbar sind.'
            ]
          },
          {
            heading: '2.3 Erweiterter Kontaktstatus',
            body: [
              'Der Kontaktstatus zeigt nun zusätzlich die nächste Wiedervorlage und den nächsten Termin.'
            ]
          },
          {
            heading: '2.4 Erweiterte Umsatzdarstellung',
            body: [
              'Neben dem Gesamtumsatz werden nun zusätzlich die Umstäze der Produktgruppen angezeigt: GS, OMP, TB und Ö.'
            ]
          },
          {
            heading: '2.5 Optimierte User-Avatare',
            body: [
              'Die Darstellung der User-Avatare wurde kompakter gestaltet, sodass mehr Kunden gleichzeitig angezeigt werden können.'
            ]
          }
        ]
      },
      {
        title: 'Reminder',
        items: [
          {
            heading: '3.1 Neues Reminder-Design',
            body: [
              'Der Reminder wurde vollständig überarbeitet. Statt eines festen Footers befindet sich dieser nun kompakt und aufklappbar am unteren linken Bildschirmrand.',
              'Vorteile: mehr Platz für Kundeninformationen, bessere Übersicht und effizienteres Arbeiten.'
            ]
          }
        ]
      },
      {
        title: 'User-Menü',
        items: [
          {
            heading: '4.1 Neues User-Menü',
            body: [
              'Das User-Menü wurde erweitert. Der Logout wurde integriert und dient zukünftig als zentraler Bereich für weitere persönliche Einstellungen.'
            ]
          },
          {
            heading: '4.2 Sales-Manager-Auswahl verschoben',
            body: [
              'Die Auswahl des Sales Managers für Area Manager und Verlagsverantwortliche befindet sich nun direkt im User-Menü.'
            ]
          },
          {
            heading: '4.3 Erweiterte Benutzerinformationen',
            body: [
              'Über Hover werden zusätzliche Informationen angezeigt: eigene Benutzerdaten, aktive Sales-Manager-Auswahl und aktuelle Zuordnung.'
            ]
          }
        ]
      },
      {
        title: 'Kundendetails',
        items: [
          {
            heading: '5.1 Optimierte Darstellung von Mahnstufen & Sperren',
            body: [
              'Mahnstufen und Sperren werden nun getrennt und übersichtlicher dargestellt.'
            ]
          },
          {
            heading: '5.2 Automatische Entscheider-Auswahl',
            body: [
              'Neu erstellte Entscheider werden automatisch im Kontaktierungsstatus vorausgewählt. Der Hauptentscheider bleibt standardmäßig gesetzt.'
            ]
          },
          {
            heading: '5.3 Verbesserte Entscheider-Bearbeitung',
            body: [
              'Die Bearbeitung der Anrede wurde erweitert und kann nun jederzeit angepasst werden.'
            ]
          },
          {
            heading: '5.4 Erweiterte Kontakthistorie',
            body: [
              'Die Kontakthistorie zeigt nun zusätzlich User-Avatare und den Ansprechpartner des Kontakts.'
            ]
          },
          {
            heading: '5.5 Neuer Hinweis bei Terminbestätigungen',
            body: [
              'Bei Sugar-Leads und Eigenrecherchen wird nun ein Hinweis angezeigt: Bei Sugar-Leads oder Eigenrecherchen können aus technischen Gründen derzeit noch keine Terminbestätigungen an ausgewählte Entscheider versendet werden.'
            ]
          },
          {
            heading: '5.6 Neue Kunden-Navigation',
            body: [
              'Neue Weiter- und Zurück-Buttons wurden integriert. Zusätzlich kann die Navigation über die Pfeiltasten genutzt werden, damit Kunden deutlich schneller bearbeitet werden können.'
            ]
          },
          {
            heading: '5.7 Optimierte Statusanzeigen',
            body: [
              'Kontaktierungsstatus und Hinweise wurden weiter verbessert und werden nun konsistenter dargestellt.'
            ]
          }
        ]
      }
    ]
  },
    {
      version: '26.1.6',
      date: '2026-05-04T10:00:00',
      title: 'Mai 2026 – Große Kunden können wieder gespeichert werden',
      items: [
        {
          heading: 'Fehlerhaftes Speichern bei Kunden mit großen Datenmengen behoben',
          body: [
            'Es gab einen Fehler, der dazu führte, dass Kunden mit großen Datenmengen (z.B. viele Kontakte, Aufträge, Tickets) nicht mehr gespeichert werden konnten. Dieser Fehler wurde behoben, sodass auch Kunden mit umfangreichen Informationen jetzt wieder problemlos bearbeitet und gespeichert werden können.'
          ]
        },
      ]
    },
    {
    version: '26.1.5',
    date: '2026-04-30T12:30:00',
    title: 'April 2026 – Eigenrecherche – Kunden können wieder übernommen werden',
    items: [
      {
        heading: 'Fehlerhafte Übernahme der Eigenrecherche behoben',
        body: [
          'Es gab einen Fehler, der dazu führte, dass Kunden im Eigenrecherche-Prozess nicht mehr übernommen werden konnten. Dieser Fehler wurde behoben, sodass die Übernahme von Kunden jetzt wieder reibungslos funktioniert.'
        ]
      },
    ]
  },
  {
    version: '26.1.4',
    date: '2026-04-24T10:00:00',
    title: 'April 2026 – S4-Abowelt, Tickets & Filter-UX',
    items: [
      {
        heading: 'Darstellung der neuen S4-Abowelt',
        body: [
          '1.1 In der "360 Grad Produktsicht" im Kundenprofil werden jetzt die neuen Tarife und SB-Bestellnummern der S4-Abowelt angezeigt. Damit sind Aufträge und Kündigungseingänge ab dem 01.01.2026 wieder vollständig sichtbar.',
          'Hinweis: Die Bestellunterlagen (Auftragsbestätigungen und Rechnungen) ab 01.01.2026 fehlen aktuell noch, da die Anbindung des neuen Archivs an Sugar-CRM in Arbeit ist.',
          '1.2 Die Darstellung der S4-Abowelt wurde optisch überarbeitet, damit die neuen Tarife und Bestellnummern klar und übersichtlich präsentiert werden.',
          '1.3 Die Positions-Nummern wurden angepasst, um eine konsistente Darstellung in der Übersicht zu gewährleisten.',
          '1.4 Bestelldatum wurde hinzugefügt, damit du den zeitlichen Kontext der Aufträge besser nachvollziehen kannst.',
          '1.5 Abo Aufträge werden nun mit einem klaren Hinweis "Abo" gekennzeichnet, damit du auf einen Blick erkennst, welche Aufträge zu den neuen S4-Abos gehören.',
        ]
      },
      {
        heading: 'Tickets zum Kunden in der Übersicht',
        body: [
          'In der Kundenübersicht werden nun alle vorhandenen Tickets (z.B. Reklamationen, Rechnungsklärungen, Korrekturwünsche) samt Bearbeitungsstatus angezeigt. So habt ihr immer einen aktuellen Überblick über offene Klärungen zum Kunden.'
        ]
      },
      {
        heading: 'Optimierungen bei der Eigenrecherche',
        body: [
          'Verbesserte Dubletten-Prüfung und allgemeine Optimierungen für die Eigenrecherche.'
        ]
      },
      {
        heading: 'Filter-Funktionen auf dem Dashboard',
        body: [
          '4.1 Der zuletzt aktive Filter wird jetzt direkt auf dem Dashboard oberhalb der "To Dos" (Termine und Wiedervorlagen) angezeigt. Ihr könnt so direkt die gefilterte Liste öffnen oder über "Zur vollen Liste" auf alle Firmen springen.',
          '4.2 Die reduzierten Filteranzeige kann man aufklappen, um die Details zu sehen.',
          '4.3 Die Buttons für Termine Feedback, Termine Heute, Wiedervorlagen ToDo und WVL Heute sollten euch nun wieder zu den richtigen Ergebnissen führen.'
        ]
      }
    ]
  },
  {
    version: '26.1.1',
    date: '2026-03-20T00:00:00',
    title: 'März 2026 – Filter & Entscheider im Feinschliff',
    items: [
      {
        heading: 'Filter – stabileres Speichern und klarere Meldungen',
        body: [
          '1.1 Filtereinstellungen werden jetzt zuverlässiger im Nutzerkontext gespeichert: Nach einem Navigationswechsel oder einem Sprung über das Dashboard kommst du mit denselben Filtern zurück in die Kundenliste.',
          '1.2 Die Suche ist Teil der Filter-Signatur: Wenn du denselben Filter inklusive Suchbegriff erneut anwendest, erscheint eine deutliche Meldung direkt unter der Sticky-Filterleiste und zeigt mit einem kurzen Countdown an, dass der Filter bereits aktiv ist.',
          '1.3 Während diese Meldung sichtbar ist, wird der darunterliegende Filter-Container vom Scrollen abgehalten – so bleibt der Fokus auf der Rückmeldung und du kannst den Filter gezielt anpassen oder schließen.',
          '1.4 Die Filter-Logik wurde überarbeitet, Filter werden jetzt pro Nutzer gespeichert und beim Routing korrekt übernommen.',
          '1.5 Nach dem Zurückgehen bleibt die zuletzt gewählte Liste erhalten.',
          '1.6 Die Suche nach GP-Nummern ist jetzt case-insensitive.'
        ]
      },
      {
        heading: 'Kundenliste – Paginierung statt automatischem Scrollen',
        body: [
          '2.1 Das automatische Weiterscrollen beim Klick auf „Mehr laden“ wurde entfernt: Die Liste springt nicht mehr von selbst nach unten, sondern bleibt an der aktuellen Position, sodass du die neu geladenen Einträge in Ruhe sichten kannst.',
          '2.2 Zwischen jeweils 24 Kunden wird jetzt ein Trenner angezeigt, damit du die Gruppen besser unterscheiden kannst.'
        ]
      },
      {
        heading: 'Entscheider-Bearbeitung – gesperrte Stammdaten klar gekennzeichnet',
        body: [
          '3.1 Beim Bearbeiten bestehender Entscheider sind Anrede (Gender), Vorname und Nachname gesperrt und werden deutlich rot markiert – so ist auf einen Blick erkennbar, welche Stammdaten nicht geändert werden sollen.',
          '3.2 Entscheider können nur noch ausgewählt werden, wenn Anrede, Vorname, Nachname und eine gültige E-Mail vorhanden sind.',
          '3.3 Die Auswahl eines unvollständigen Entscheiders ist technisch und im UI vollständig blockiert.',
          '3.4 Die rote "Unvollständig"-Pille wird im Dropdown und in der Infoanzeige angezeigt, wenn einer der Pflichtwerte fehlt.',
          '3.5 Die Pille erscheint nur, wenn wirklich ein Pflichtfeld fehlt – die Logik prüft alle möglichen Felder.',
          '3.6 Das Layout des Dropdowns wurde angepasst: Die Pille ist immer sichtbar, die Badges "Neu" und "Haupt" werden korrekt kombiniert angezeigt.',
          '3.7 Der Trigger-Button zeigt den Platzhalter "Bitte Entscheider auswählen", wenn kein gültiger Entscheider gewählt ist.',
          '3.8 Die Validierung und Auswahl-Logik ist zentralisiert und robust gegen externe oder fehlerhafte Zuweisungen.',
          '3.9 Fehlerhafte oder unvollständige Kontakte werden automatisch aus der Auswahl entfernt.',
          '3.10 Telefonnummern von Entscheidern werden nach Änderungen sofort aktualisiert.'
        ]
      },
      {
        heading: 'Eigenrecherche – klarere Steuerung und faire Kapazitäten',
        body: [
          '4.1 Das Dropdown für die Listenansicht wechselt jetzt korrekt zwischen den Listen, auch nach Routing-Änderungen.'
        ]
      },
      {
        heading: 'Weitere Verbesserungen und Bugfixes',
        body: [
          '5.1 Lade-Spinner und Statusanzeigen wurden verbessert.',
          '5.2 Diverse Bugfixes und UI-Feinschliff.'
        ]
      },
    ]
  },
  {
    version: '26.1.0-dev',
    date: '2026-03-12T00:00:00',
    title: 'März 2026 – Mehr Überblick und leichteres Arbeiten im Verkauf',
    items: [
      {
      heading: 'Neues Changelog – alle Neuerungen auf einen Blick',
        body: [
          '1.1 Es gibt jetzt eine eigene Changelog-Ansicht, in der alle Neuerungen übersichtlich sortiert sind.',
          '1.2 Im Dashboard und in der Navigation siehst du sofort, ob es neue Einträge gibt – inklusive Zähler für ungelesene Versionen.',
          '1.3 Das Layout des Changelogs passt sich an das bestehende Design an und lässt sich bequem lesen – auch im Vertriebsalltag zwischendurch.'
        ]
      },
      {
      heading: 'Potential & BK – Zähler schneller und verlässlicher',
        body: [
        '2.1 Die Zähler im Bereich Potential & BK, Wiedervorlagen und Terminen reagieren jetzt schneller und zeigen einheitliche Werte in Dashboard und Navigation. Die Zählung orientiert sich direkt an der tatsächlichen Trefferanzahl – so siehst du sofort, wie viele Kunden wirklich hinter einem Button stecken. Im Dashboard-Widget „Potential & BK“ zeigen die vier Aktionskarten (Wiedervorlagen, Termine, To-Dos) diesen Zähler von Anfang an mit einem klaren Ladezustand und aktualisieren ihre Werte im Hintergrund, ohne beim Zurückspringen aus der Liste unnötig neu zu laden.',
        '2.2 Die Zusammenfassung der gesetzten Filter ist übersichtlicher geworden: Über die kleinen Filter-Badges oberhalb der Liste kannst du gezielt zu einzelnen Filterbereichen springen und behältst auch bei komplexen Einstellungen leichter den Überblick.',
      '2.3 Die Gestaltung der Potential-&-BK-Tabelle wurde überarbeitet: Spalten sind neu angeordnet, Hervorhebungen wurden angepasst und die Darstellung ist insgesamt übersichtlicher. Steht ein Kunde in mehreren Listen, werden die zugehörigen Sales Manager sichtbar: Area Manager sehen dann einen uneindeutigen Status, da jeder Sales Manager einen eigenen Status haben kann. Als Sales Manager siehst du auch die anderen zuständigen Sales Manager, die Statusanzeige bezieht sich aber klar auf deinen eigenen Status.',
      '2.4 Die Lead-Übersicht „Unb. Sugar Aktionen“ lädt übersichtlicher: Zuerst wird ein kurzer Ladehinweis mit Spinner angezeigt, danach entweder die verfügbaren Lead-Listen oder die Information, dass aktuell keine Leads vorhanden sind.'
        ]
      },
      {
      heading: 'BusinessPartner-Liste – flexiblere Ansicht für den Außendienst',
        body: [
          '3.1 In der Kundenliste kannst du Spalten jetzt flexibel ein- und ausblenden und die Ansicht an deine Arbeitsweise anpassen.',
          '3.2 Eine Countdown-Anzeige hilft dir, zeitkritische Kunden besser im Blick zu behalten.',
          '3.3 Für die Suche nach GP-Nummer und Telefonnummern werden deine letzten Eingaben zuverlässiger gemerkt – wiederkehrende Suchen gehen dadurch deutlich schneller von der Hand.',
      '3.4 Die Kundennummer (GPNo) ist nun auch dann klar erkennbar, wenn zu einem Kunden noch keine Kontaktperson hinterlegt ist.',
          '3.5 Die Vorschau-Suche auf dem Dashboard und die Suche in der Kundenliste zeigen jetzt klarere Ladezustände: Während eine Suche läuft, wird deutlich signalisiert, dass ein Kunde gesucht wird, und Suchbegriffe lassen sich über ein kleines rotes X-Symbol genauso bequem löschen wie in den Dropdowns.'
        ]
      },
      {
      heading: 'Eigenrecherche – klarere Steuerung und faire Kapazitäten',
        body: [
          '4.1 Die Kapazitäten für Area Manager werden klarer berechnet – dabei geht es ausdrücklich um noch unbeendete Kunden im Eigenrecherche-Prozess, nicht um komplett unbearbeitete Kunden. So ist sofort ersichtlich, wie viele Fälle noch sinnvoll weiterbearbeitet werden können.',
          '4.2 Unbeendete Eigenrecherche-Leads werden im Dashboard einheitlicher dargestellt, sodass du Kapazitäten und offene Potenziale auf einen Blick erkennst.'
        ]
      },
      {
    heading: 'Feinschliff im Design & Layout',
    body: [
      '5.1 Mehrere Oberflächen wurden optisch aufgeräumt: Abstände, Rahmen und Farben wurden angepasst, damit sich Inhalte klarer voneinander abheben.',
      '5.2 Tabellen und Listen wirken ruhiger und einheitlicher – Zeilenabstände und Spaltenbreiten wurden besser aufeinander abgestimmt.',
      '5.3 Die Lesbarkeit von Texten wurde verbessert, indem Schriftgrößen, Zeilenhöhen und max. Textbreiten an das Nutzungsszenario angepasst wurden.',
      '5.4 Buttons und wichtige Aktionen haben konsistentere Hover- und Fokuszustände bekommen, sodass besser erkennbar ist, was gerade klickbar ist.',
      '5.6 Einzelne Icons und Badges wurden harmonisiert, damit sie sich besser in das Gesamtbild des SMA-Portals einfügen.'
    ]
    },
    {
    heading: 'Login & Team-Zuordnung – reibungsloser Einstieg ins Portal',
        body: [
          '6.1 Die Zuordnung von Nutzern zu ihren Sales-Teams wurde stabilisiert, sodass Auswertungen und Filter nach Teams zuverlässiger funktionieren.',
          '6.2 Der Login über E-Mail-Adresse reagiert toleranter auf Groß- und Kleinschreibung – das reduziert Fehleingaben und spart Zeit beim Anmelden.',
          '6.3 Status-Informationen zu Kunden werden im Hintergrund zuverlässiger aktualisiert, sodass du dich auf die angezeigten Vertriebskennzahlen verlassen kannst.'
        ]
      },
      {
        heading: 'Automatische Datenaktualisierung im Hintergrund',
        body: [
          '7.1 Regelmäßige Hintergrundläufe aktualisieren Vertriebsdaten jetzt zuverlässiger, sodass Statuswechsel und Entwicklungen zeitnah im Portal sichtbar werden.'
        ]
      },
      {
        heading: 'Weitere Verbesserungen und Bugfixes',
        body: [
          '5.1 Die Prüfung auf vollständige Entscheider-Daten ist jetzt exakt: Es werden alle möglichen Felder (gender, salutation, salutationInformal, verschiedene E-Mail-Felder) geprüft.',
          '5.2 Die "Unvollständig"-Pille erscheint nur, wenn wirklich ein Pflichtfeld fehlt.',
          '5.3 Die Auswahl eines unvollständigen Entscheiders ist überall blockiert – auch bei externer Zuweisung oder nachträglicher Änderung.',
          '5.4 Das Layout des Dropdowns wurde verbessert: Die Pille ist immer sichtbar, die Badges "Neu" und "Haupt" werden korrekt kombiniert angezeigt.',
          '5.5 Der Trigger-Button zeigt den Platzhalter "Bitte Entscheider auswählen", wenn kein gültiger Entscheider gewählt ist.',
          '5.6 Die Validierung und Auswahl-Logik ist zentralisiert und robust gegen externe oder fehlerhafte Zuweisungen.',
          '5.7 Fehlerhafte oder unvollständige Kontakte werden automatisch aus der Auswahl entfernt.'
        ]
      }
    ]
  }
];

